import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { UserEmailModel } from 'user/user-email-model';

export interface UserEmailModelDocument {
	readonly id: string;
	readonly name: string;
	readonly body: string;
	readonly userId: string;
	readonly subject: string;
}

export type UserEmailModelState = EntityState<UserEmailModelDocument, string>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'userEmailModels' })
export class UserEmailModelStore extends EntityStore<UserEmailModelState> {
	constructor() {
		super();
	}

	public asEntity(document: UserEmailModelDocument): UserEmailModel {
		return document
			? new UserEmailModel(
					document.id,
					document.name,
					document.body,
					document.userId,
					document.subject
			  )
			: null;
	}

	public asDocument(entity: UserEmailModel): UserEmailModelDocument {
		return entity
			? {
					id: entity.id,
					name: entity.name,
					body: entity.body,
					userId: entity.userId,
					subject: entity.subject,
			  }
			: null;
	}
}
